import i18n, { use } from "i18next"
import { initReactI18next } from "react-i18next"
import ICU from 'i18next-icu'
import LngDetector from 'i18next-browser-languagedetector'

import translationEN from './i18n/en.json'
import translationRU from './i18n/ru.json'

const resources = {
  en: {
    translation: translationEN
  },
  // ru: {
  //   translation: translationRU
  // },
}

use(ICU)
  .use(LngDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    compatibilityJSON: 'v3',
    resources,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "langKey",
      caches: ["localStorage"]
    },
    fallbackLng: 'en',
    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n
